import React, { useState, createElement } from 'react';
import { motion } from 'framer-motion';
import { Share2, MessageCircle, Star, Link as LinkIcon, Heart, Users, Copy, Check, Quote } from 'lucide-react';
import { PageTransition } from '../components/PageTransition';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
export function SharePage() {
  const [copied, setCopied] = useState(false);
  const podcastLink = 'https://open.spotify.com/show/5nWVRvG1GtlfUXUfN77LfL';
  const handleCopyLink = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(podcastLink);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = podcastLink;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };
  return <PageTransition data-id="element-803" data-mp="103tb347sguo7">
      <div className="pt-24 pb-16 min-h-screen" data-id="element-804" data-mp="103jid8vd09et">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-805" data-mp="101qa5p53lh4p">
          {/* Hero Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-center mb-20" data-id="element-806" data-mp="14vuleklecbbl">
            <div className="w-16 h-16 bg-gold-500/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-807" data-mp="1itsx1i8c1tne">
              <Share2 className="w-8 h-8 text-gold-500" data-id="element-808" data-mp="1nschfe7a2xdn" />
            </div>
            <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-809" data-mp="3klxlgjqmi8td">
              Share the Mission
            </h1>
            <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full mb-6" data-id="element-810" data-mp="3pljxipuptj0l"></div>
            <p className="text-xl text-white/80 max-w-2xl mx-auto leading-relaxed" data-id="element-811" data-mp="3hjaz0v8awq5k">
              Help us spread the word. Every share, review, and conversation
              helps us reach more people with honest stories of faith and
              transformation.
            </p>
          </motion.div>

          {/* Ways to Share Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24" data-id="element-812" data-mp="3ml8my2rnc94u">
            {/* Social Media */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} data-id="element-813" data-mp="4bg5utcw3lxy">
              <Card className="h-full bg-dark-600 border-dark-500 p-8 text-center hover:border-gold-500/50 transition-colors group" data-id="element-814" data-mp="96caqu3863sh">
                <div className="w-14 h-14 bg-dark-500 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform" data-id="element-815" data-mp="j2yvlivjwuui">
                  <MessageCircle className="w-7 h-7 text-gold-400" data-id="element-816" data-mp="12m4gi75mb8aa" />
                </div>
                <h3 className="text-xl font-serif font-bold text-white mb-4" data-id="element-817" data-mp="16p14yehu9ym5">
                  Share on Social
                </h3>
                <p className="text-white/70 mb-8 leading-relaxed" data-id="element-818" data-mp="xp5lzni1kzbk">
                  Post your favorite episode on Facebook, Instagram, or X. Tag
                  us and let your friends know how the story impacted you.
                </p>
                <div className="flex flex-col gap-3 mt-auto" data-id="element-819" data-mp="nrzuwf9fh8bc">
                  <a href="https://www.facebook.com/sharer/sharer.php?u=https://open.spotify.com/show/5nWVRvG1GtlfUXUfN77LfL" target="_blank" rel="noopener noreferrer" data-id="element-820" data-mp="9zth2ztqzdf2">
                    <Button variant="outline" className="w-full" data-id="element-821" data-mp="1x8ofs72wkn">
                      Share to Facebook
                    </Button>
                  </a>
                  <a href="https://twitter.com/intent/tweet?url=https://open.spotify.com/show/5nWVRvG1GtlfUXUfN77LfL&text=Check%20out%20the%203%20Doves%20Podcast!" target="_blank" rel="noopener noreferrer" data-id="element-822" data-mp="18b4dkl433qzw">
                    <Button variant="outline" className="w-full" data-id="element-823" data-mp="tmhpnv0e5qx2">
                      Share to X
                    </Button>
                  </a>
                </div>
              </Card>
            </motion.div>

            {/* Send a Link */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} data-id="element-824" data-mp="kl0f0s5r6hfr">
              <Card className="h-full bg-dark-600 border-dark-500 p-8 text-center hover:border-gold-500/50 transition-colors group" data-id="element-825" data-mp="29zeyoy1wze4e">
                <div className="w-14 h-14 bg-dark-500 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform" data-id="element-826" data-mp="24zk52mqr8afn">
                  <LinkIcon className="w-7 h-7 text-gold-400" data-id="element-827" data-mp="2hj7g9ga9qmua" />
                </div>
                <h3 className="text-xl font-serif font-bold text-white mb-4" data-id="element-828" data-mp="2mapehwkwq9bk">
                  Send a Link
                </h3>
                <p className="text-white/70 mb-6 leading-relaxed" data-id="element-829" data-mp="2r9iv3xvhqgfy">
                  Know someone who needs to hear a specific message? Grab the
                  link and text it directly to a friend or family member.
                </p>
                <div className="mb-4 p-3 bg-dark-700 rounded-lg border border-dark-400 flex items-center gap-2" data-id="element-830" data-mp="23khgttzz8b2r">
                  <LinkIcon className="w-4 h-4 text-gold-500 flex-shrink-0" data-id="element-831" data-mp="28jat5j3j1w1c" />
                  <span className="text-white/60 text-sm truncate select-all" data-id="element-832" data-mp="28h7yumvcdgqt">
                    {podcastLink}
                  </span>
                </div>
                <div className="mt-auto flex flex-col gap-3" data-id="element-833" data-mp="3jxemqo67di5v">
                  <Button variant="primary" className="w-full" onClick={handleCopyLink} leftIcon={copied ? <Check className="w-4 h-4" data-id="element-835" data-mp="1sxfythnt82sp" /> : <Copy className="w-4 h-4" data-id="element-836" data-mp="1ov1j36fftj5n" />} data-id="element-834" data-mp="1jvyo6et68tbe">
                    {copied ? 'Link Copied!' : 'Copy Podcast Link'}
                  </Button>
                  <a href={podcastLink} target="_blank" rel="noopener noreferrer" data-id="element-837" data-mp="w7ovcsxjj5ar">
                    <Button variant="outline" className="w-full" data-id="element-838" data-mp="1a054mbh1bzk4">
                      Open in Spotify
                    </Button>
                  </a>
                </div>
              </Card>
            </motion.div>

            {/* Word of Mouth */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} data-id="element-839" data-mp="dfcsm52z6203">
              <Card className="h-full bg-dark-600 border-dark-500 p-8 text-center hover:border-gold-500/50 transition-colors group" data-id="element-840" data-mp="3pkqnc6zu2v7d">
                <div className="w-14 h-14 bg-dark-500 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform" data-id="element-841" data-mp="3ugo58hqqw9m9">
                  <Users className="w-7 h-7 text-gold-400" data-id="element-842" data-mp="r10j3qu2iyqz" />
                </div>
                <h3 className="text-xl font-serif font-bold text-white mb-4" data-id="element-843" data-mp="c5avjo98idk5">
                  Tell a Friend
                </h3>
                <p className="text-white/70 mb-8 leading-relaxed" data-id="element-844" data-mp="h2kpnh7kjdeb">
                  The most powerful way to share is through personal
                  conversation. Mention the podcast at your small group, church,
                  or over coffee.
                </p>
                <div className="mt-auto flex items-center justify-center text-gold-500 font-medium" data-id="element-845" data-mp="2j43o8s8mri60">
                  <Heart className="w-5 h-5 mr-2" data-id="element-846" data-mp="2e47sfga36x1j" />
                  <span data-id="element-847" data-mp="2e6kadtfuh7el">Share from the heart</span>
                </div>
              </Card>
            </motion.div>
          </div>

          {/* Reviews Section */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-dark-800 rounded-2xl p-8 md:p-12 border border-dark-600 mb-24 relative overflow-hidden" data-id="element-848" data-mp="25548ka33idlz">
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold-500/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-849" data-mp="2o1lx6imndxe0"></div>

            <div className="flex flex-col md:flex-row items-center gap-12 relative z-10" data-id="element-850" data-mp="3klupb2rhywhd">
              <div className="w-full md:w-1/2" data-id="element-851" data-mp="3fsjnxh5gf7wu">
                <div className="flex items-center mb-6" data-id="element-852" data-mp="12bqcrk8vnbsl">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-6 h-6 text-gold-500 fill-gold-500 mr-1" data-id="element-853" data-mp="179i4ad5m0vw9" />)}
                </div>
                <h2 className="text-3xl font-serif font-bold text-white mb-4" data-id="element-854" data-mp="1gb86me115f8t">
                  Leave a Review
                </h2>
                <p className="text-lg text-white/80 mb-8 leading-relaxed" data-id="element-855" data-mp="1l9jewkbofhox">
                  Reviews and ratings are crucial for helping new listeners
                  discover the podcast. Taking just 60 seconds to rate and
                  review us on Apple Podcasts or Spotify makes a massive
                  difference.
                </p>
                <div className="flex flex-col sm:flex-row gap-4" data-id="element-856" data-mp="240srj2gqumkq">
                  <a href="https://podcasts.apple.com/us/podcast/3-doves-podcast/id1871795398" target="_blank" rel="noopener noreferrer" data-id="element-857" data-mp="23yfztxl6oxuh">
                    <Button className="w-full sm:w-auto" data-id="element-858" data-mp="1m66pkjtwjmsp">
                      Review on Apple
                    </Button>
                  </a>
                  <a href="https://open.spotify.com/show/5nWVRvG1GtlfUXUfN77LfL" target="_blank" rel="noopener noreferrer" data-id="element-859" data-mp="1q6ph0crvuqud">
                    <Button variant="outline" className="w-full sm:w-auto" data-id="element-860" data-mp="1zwsbkhenkcut">
                      Rate on Spotify
                    </Button>
                  </a>
                </div>
              </div>

              <div className="w-full md:w-1/2" data-id="element-861" data-mp="29w9e4pylyamk">
                <div className="bg-dark-700 p-8 rounded-xl border border-dark-500 relative" data-id="element-862" data-mp="2dx321jc1vpfg">
                  <Quote className="absolute top-4 right-4 w-12 h-12 text-dark-500" data-id="element-863" data-mp="fhqd6rtpsf6n" />
                  <p className="text-white/90 italic text-lg leading-relaxed relative z-10" data-id="element-864" data-mp="fk325oxw3pt7">
                    "This podcast has been such an encouragement to my daily
                    walk. Hearing real, unpolished stories of how God is working
                    in everyday people reminds me that He's working in my life
                    too."
                  </p>
                  <div className="mt-6 flex items-center" data-id="element-865" data-mp="2a9bc0o71bvz">
                    <div className="w-10 h-10 bg-dark-500 rounded-full flex items-center justify-center text-gold-400 font-bold" data-id="element-866" data-mp="3uelb6ggun6jt">
                      L
                    </div>
                    <div className="ml-3" data-id="element-867" data-mp="pztvgmw32f6u">
                      <p className="text-white font-medium" data-id="element-868" data-mp="q0vg9j2wig1r">Listener Review</p>
                      <p className="text-white/50 text-sm" data-id="element-869" data-mp="lx77wy6g3gfg">Apple Podcasts</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Bottom Quote */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center max-w-3xl mx-auto" data-id="element-870" data-mp="36pixfjpc5xul">
            <h3 className="text-2xl font-serif font-bold text-gold-400 mb-4" data-id="element-871" data-mp="2u5lxt70fdmcd">
              "They triumphed over him by the blood of the Lamb and by the word
              of their testimony."
            </h3>
            <p className="text-white/60 uppercase tracking-widest text-sm" data-id="element-872" data-mp="2kg2bfrdi7acr">
              Revelation 12:11
            </p>
          </motion.div>
        </div>
      </div>
    </PageTransition>;
}